module.exports = __webpack_public_path__ + "media/images/greek-logos-f731fda08a14c0072e4d7fffbf6c2c91.svg";